import { render, staticRenderFns } from "./WarehouseDetailDeliveries.vue?vue&type=template&id=3584ee65&scoped=true&"
import script from "./WarehouseDetailDeliveries.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetailDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseDetailDeliveries.vue?vue&type=style&index=0&id=3584ee65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584ee65",
  null
  
)

export default component.exports